import styled from '@emotion/styled';

export const ApplicationDetailsContainer = styled.div`
  width: 100%;
  height: 100%;
`;
